import { MobileHeader } from '@components/smart';
import { matchPath, useLocation } from 'react-router-dom';
import { useIsMobile } from '../../hooks/ui/useMediaQuery';

const ROUTES_WITHOUT_HEADER = [
  { path: '/tasks/:id', end: true },
  { path: '/groups', end: true },
  { path: '/tasks-new', end: true },
  { path: '/tasks-new/:id', end: true },
  { path: '/tools/:toolId', end: true },
  { path: '/disk', end: true },
];

const MOBILE_ROUTES_WITHOUT_HEADER = [{ path: '/projects', end: true }];

function matchesAnyRoute(
  pathname: string,
  routes: typeof ROUTES_WITHOUT_HEADER
) {
  return routes.some((route) => matchPath(route, pathname));
}

export function Header() {
  const isMobile = useIsMobile();
  const { pathname } = useLocation();

  if (!isMobile) {
    return null;
  }

  const isHeaderDisabled = matchesAnyRoute(pathname, ROUTES_WITHOUT_HEADER);
  const isMobileHeaderDisabled = matchesAnyRoute(
    pathname,
    MOBILE_ROUTES_WITHOUT_HEADER
  );

  if (isHeaderDisabled || isMobileHeaderDisabled) {
    return null;
  }

  return <MobileHeader />;
}
